// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"336c9d83","425":"fd1216a9","428":"8dfa481d","453":"ce124572","459":"b1d64ffa","499":"d7760a11","542":"c7103ebf","581":"20b93a6b","583":"c0359387","630":"d24c9584","956":"f1238f97","982":"ca01386e"}[chunkId] + ".chunk.js";
};